module.exports = __webpack_public_path__ + "static/entrepreneur-2-2024-89fe00a277b48513e37b33d1aecae5d5.webp";